export default __webpack_public_path__ + "images/37ba9f8277a2b85c995afb0592688d55.svg";